import { Outlet } from "react-router-dom";
import styled from "styled-components";

//
import Navbar from "../../components/navbar";

export default function LessonLayout() {
  return (
    <StyledLessonLayout className="d-flex flex-column x-h-md-100">
      <Navbar fluid />
      <Outlet />
    </StyledLessonLayout>
  );
}

const StyledLessonLayout = styled.div``;
